/*
 * The markup below is externally authored animation artwork
 * Re-export from the source instead of modifying it directly.
 *
 */
import { Box } from '@mui/material';

import styles from './InovonicsPendantAnimation.module.css';

export default function InovonicsPendantAnimation() {
    return (
        <Box
            sx={{
                width: '100%',
                height: 193,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden',
                borderRadius: 2,
                bgcolor: 'neutral.100',
            }}
        >
            <Box
                sx={{
                    zoom: 0.48,
                    transform: 'translateX(-134px)',
                }}
            >
                <div className={styles['wb-widget']} aria-hidden="true">
                    <div className={styles.stage}>
                        <div className={styles.shadow} />
                        <div className={styles.strap} />
                        <div className={styles.body} />
                        <div className={styles.bezel} />
                        <div className={styles['button-highlight']} />
                        <div className={styles.button} />
                        <div className={styles.indicator} />
                        <div className={`${styles.ripple} ${styles.r1}`} />
                        <div className={`${styles.ripple} ${styles.r2}`} />
                        <div className={styles.field} />
                        <div className={styles.card}>
                            <div className={styles['card-end']} />
                            <div className={styles['card-body']} />
                            <div className={styles['card-label']} />
                            <div className={styles['card-slot']} />
                            <div className={styles['card-magnet']} />
                        </div>
                    </div>
                </div>
            </Box>
        </Box>
    );
}
